import { useQuery } from 'react-query';
import { HeadingPages } from '../../../components/HeadingPages';
import { api } from '../../../services/api';
import { TableContainer } from '@chakra-ui/react';
import * as T from '../../../components/Table';
import { UsersList } from './UsersList';

async function getUsers() {
  const response = await api.get('/site/v2/fluxo-liberacao/listar-usuarios');

  return response.data.map((item) => {
    return {
      ...item,
      usuario_ativo: item.usuario_ativo === 'S',
      liberador: item.liberador === 'S',
      ativo_fila: item.ativo_fila === 'S'
    };
  });
}

export function ControleUsuarios() {
  const { data: users, isLoading } = useQuery({
    queryKey: 'users',
    queryFn: getUsers,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });

  return (
    <>
      <HeadingPages name="Controle Usuarios" />

      <TableContainer p="4">
        <T.Table borderCollapse="collapse" size="sm">
          <T.Thead>
            <T.Tr>
              <T.Th>Nome Usuário</T.Th>
              <T.Th>Código Usuário</T.Th>
              <T.Th>Ativo Fila</T.Th>
              <T.Th>E-mail</T.Th>
              <T.Th>Login CRM</T.Th>
              <T.Th>Liberador</T.Th>
              <T.Th>Usuário ativo</T.Th>
              <T.Th />
            </T.Tr>
          </T.Thead>
          <T.Tbody>
            {isLoading ? (
              <T.Tr>
                <T.Td colSpan="7">Carregando...</T.Td>
              </T.Tr>
            ) : (
              <UsersList list={users} />
            )}
          </T.Tbody>
        </T.Table>
      </TableContainer>
    </>
  );
}
